import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import { PermissionsEnum } from '../../containers/contexts/permissions/constants'
import { usePermissions } from '../../hooks'
import styles from './AppSubHeader.module.less'

const AppSubHeader = () => {
  const history = useHistory()
  const { hasPermission } = usePermissions()
  const handleLocationChange = (location: string) => {
    history.push({ pathname: location })
  }

  return (
    <div className={`${styles.subNavWrap} sub-nav`}>
      <Button className={`${styles.subNavButton} search-button`} disabled>
        Search
      </Button>
      {(hasPermission(PermissionsEnum.TradeReportsRead) || hasPermission(PermissionsEnum.TradeReportsModify)) && (
        <Button
          className={`${styles.subNavButton} ${styles.active} trade-entry-button`}
          onClick={() => handleLocationChange('/')}
        >
          Trade Entry
        </Button>
      )}
    </div>
  )
}

export default AppSubHeader
